
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { Box, CircularProgress, Typography, Paper } from "@mui/material";

// const Settings = () => {
//   const [message, setMessage] = useState("");
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchSettings = async () => {
//       const currentUser = sessionStorage.getItem("currentUser");
//       const token = sessionStorage.getItem(`token_${currentUser}`);

//       if (!token) {
//         navigate("/");
//         return;
//       }

//       try {
//         const response = await axios.get("http://localhost:5000/settings", {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setMessage(response.data.message);
//       } catch (error) {
//         alert("❌ Unauthorized. Redirecting to login.");
//         navigate("/");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchSettings();
//   }, [navigate]);

//   return (
//     <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
//       <Paper elevation={3} sx={{ padding: "20px", textAlign: "center", width: "400px" }}>
//         <Typography variant="h4" gutterBottom>Settings Page</Typography>
//         {loading ? (
//           <CircularProgress />
//         ) : (
//           <Typography variant="body1">{message || "No settings available."}</Typography>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default Settings;
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";

// function Settings() {
//   const [message, setMessage] = useState("");
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchSettings = async () => {
//       const token = localStorage.getItem("token");
//       if (!token) {
//         navigate("/");
//         return;
//       }

//       try {
//         const response = await axios.get("http://localhost:5000/settings", {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setMessage(response.data.message);
//       } catch (error) {
//         alert("Unauthorized");
//         navigate("/");
//       }
//     };

//     fetchSettings();
//   }, [navigate]);

//   return (
//     <div>
//       <h2>Settings Page</h2>
//       <p>{message}</p>
//     </div>
//   );
// }

// export default Settings;
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography, Paper } from "@mui/material";

const Settings = () => {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
let sessionExpiredHandled = false;
  useEffect(() => {
    const fetchSettings = async () => {
      const currentUser = sessionStorage.getItem("currentUser");
      const token = sessionStorage.getItem(`token_${currentUser}`);

      if (!token) {
        navigate("/");
        return;
      }

      try {
        const response = await axios.get("http://localhost:5000/settings", {
          headers: { authorization: `Bearer ${token}` },
        });
        console.log('response',response);
        
        setMessage(response.data.message);
      } catch (error) {
         const msg = error.response?.data?.message;

        //alert("❌ Unauthorized. Redirecting to login.");
      //  navigate("/");
      if ((msg === 'Token has expired' || msg === 'Invalid token') && sessionExpiredHandled ===false) {
        sessionExpiredHandled=true
    alert('⏰ Session expired. Logging you out.');

    // 🔐 Clear token and user info
    const currentUser = sessionStorage.getItem("currentUser");
    sessionStorage.removeItem(`token_${currentUser}`);
    sessionStorage.removeItem("currentUser");

    // ⛔ Navigate to login
    navigate("/");
  } else {
    //alert("⚠️ Something went wrong.");
  }
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, [navigate]);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
      <Paper elevation={3} sx={{ padding: "20px", textAlign: "center", width: "400px" }}>
        <Typography variant="h4" gutterBottom>Settings Page</Typography>
        {loading ? (
          <CircularProgress />
        ) : (
          <Typography variant="body1">{message || "No settings available."}</Typography>
        )}
      </Paper>
    </Box>
  );
};

export default Settings;